

const DataCaptureSelectorActions = function DataCaptureSelectorActions(Flux, APP_DISPATCHER_ID) {

  const Actions = Flux.Actions.create('DataCaptureSelectorActions', APP_DISPATCHER_ID);

  Actions.add({
    name: 'DateChanged',
    purpose: 'Detect when a date is selected in the date picker',
    payload: ['data']
  });

  Actions.add({
    name: 'DatacaptureSelected',
    purpose: 'Detect when a datacapture is selected in the datacaptures list',
    payload: ['data']
  });

  Actions.add({
    name: 'DataCaptureChanged',
    purpose: 'Detect when a datacapture is selected in the date picker',
    payload: ['data']
  });

  Actions.add({
    name: 'DataCaptureLoaded',
    purpose: 'Detect when a datacapture load has finished',
    payload: ['data']
  });

  Actions.add({
    name: 'NewestDatacapture',
    purpose: 'Show the newest datacapture available',
    payload: ['data']
  });

  Actions.add({
    name: 'PreviousDatacapture',
    purpose: 'Show the previous datacapture available',
    payload: ['data']
  });

  Actions.add({
    name: 'NextDatacapture',
    purpose: 'Show the next datacapture available',
    payload: ['data']
  });

  return Actions;
};

DataCaptureSelectorActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];
module.exports = DataCaptureSelectorActions;



// WEBPACK FOOTER //
// ./src/app/dash/topControls/dataCaptureSelector/DataCaptureSelectorActions.js